import styled from 'styled-components';
import { key } from 'styled-theme';
import { prop } from 'styled-tools';

import { headingStyle } from 'components/typo/Heading/utils';

export default styled.div<{ css?: string | Array<string> }>`
  h1 {
    ${headingStyle('h1')};
  }

  h2 {
    ${headingStyle('h2')};
  }

  h3 {
    ${headingStyle('h3')};
  }

  h4 {
    ${headingStyle('h4')};
  }

  p {
    color: ${key('text.paragraph.color')};
  }

  ${prop('css', '')}
`;
